import { ParcelDimensions } from './consolidator';

export const dimensionAxes = ['length', 'width', 'height'] as const;

export type DimensionsDraft = Record<(typeof dimensionAxes)[number], string>;

export const emptyDimensionsDraft: DimensionsDraft = { length: '', width: '', height: '' };

export const isValidSize = (value: string) => Number.isFinite(Number(value)) && Number(value) > 0;

export const isValidDimensionsDraft = (draft: DimensionsDraft) =>
  dimensionAxes.every((axis) => isValidSize(draft[axis]));

export const toParcelDimensions = (draft: DimensionsDraft): ParcelDimensions => ({
  length: { value: Number(draft.length), unit: 1 },
  width: { value: Number(draft.width), unit: 1 },
  height: { value: Number(draft.height), unit: 1 },
});
